import React, { useEffect, useRef, useState } from "react";
import { Box, Button, useMediaQuery } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";

interface Props {
  handleShow(value: string): void;
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
}

export default function Header(props: any) {
  const links = ["home", "about", "projects", "skills", "experience", "contacts"];

  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMobileDrawerToggle = (value) => {
    props.handleShow(value);
    setTimeout(() => {
      setMobileOpen(!mobileOpen);
    }, 300);
  };

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return; // SSR guard

    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // initial check
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // const container = window !== undefined ? () => window().document.body : undefined;
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  return (
    <>
      <div className={`header ${scrolled ? "scrolled" : ""}`}>
        <Box className="nav-content" display="flex" px={12} py={2} flexDirection={"row"} justifyContent="flex-end" sx={{ display: { xs: "none", sm: "none", md: "flex" } }}>
          {links &&
            links.map((value, key) => (
              <>
                <Button key={value} onClick={() => props.handleShow(value)}>
                  <span className={"ui-padding--h-12 ui-typo--h6" + (prefersDarkMode ? "text-color-black" : "text-color-black")}>{value}</span>
                </Button>
                <div className="ui-padding--4"></div>
              </>
            ))}
          <Box px={1} py={1} width={86}>
            <a
              className="ui-padding--8 ui-cursor--pointer"
              target="_blank"
              href="https://firebasestorage.googleapis.com/v0/b/portfolio-76503.appspot.com/o/resume_2025%2Fbharath_2026_amazon.pdf?alt=media&token=16abffb8-2915-4720-82c4-bdd742acaa60"
              rel="noreferrer"
            >
              <span className={"ui-padding--h-12 ui-theme--primary ui-text--uppercase ui-typo--h6 " + (prefersDarkMode ? "text-color-white" : "text-color-white")}>Resume</span>
            </a>

            {/* <a className="ui-padding--8 ui-cursor--pointer"
              target="_blank"
              href="image"
              rel="noreferrer"
            >ImageUploader</a> */}
          </Box>
        </Box>

        {/* mobile drawer  */}

        <Box px={2}>
          <IconButton color="inherit" aria-label="open drawer" edge="start" onClick={handleDrawerToggle} sx={{ mr: 4, display: { md: "none" } }}>
            <MenuIcon className="ui-icon--30" />
          </IconButton>
        </Box>

        <Box component="nav" sx={{ mr: 2, display: { md: "none" } }}>
          <Drawer
            className="ui-glassmoprhi"
            // container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { sm: "block", md: "none" },
              "& .MuiDrawer-paper": { boxSizing: "border-box", width: 240 },
            }}
          >
            <Box className="ui-width--full" px={3} py={3} sx={{ textAlign: "center" }}>
              {links &&
                links.map((value, key) => (
                  <Button className="ui-margin--8 ui-width--full " key={value} onClick={() => handleMobileDrawerToggle(value)}>
                    <span className="ui-padding--12 ui-width--full ui-typo--h5">{value}</span>
                  </Button>
                ))}
              <Box px={3} pt={2}>
                <a
                  className="ui-padding--8 ui-cursor--pointer"
                  target="_blank"
                  href="https://firebasestorage.googleapis.com/v0/b/portfolio-76503.appspot.com/o/resume_2025%2Fbharath_2026_amazon.pdf?alt=media&token=16abffb8-2915-4720-82c4-bdd742acaa60"
                  rel="noreferrer"
                >
                  <span className={"ui-padding--12 ui-theme--prima ui-text--uppercase ui-typo--h5  " + (prefersDarkMode ? "text-color-white" : "text-color-white")}>Resume</span>
                </a>
              </Box>
            </Box>
          </Drawer>
        </Box>
      </div>
    </>
  );
}
